import { render, staticRenderFns } from "./multiple-client-select.vue?vue&type=template&id=0e534454&scoped=true"
import script from "./multiple-client-select.vue?vue&type=script&lang=js"
export * from "./multiple-client-select.vue?vue&type=script&lang=js"
import style0 from "./multiple-client-select.vue?vue&type=style&index=0&id=0e534454&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e534454",
  null
  
)

export default component.exports